export default __webpack_public_path__ + "static/media/banner-bottom.b393de10.png";